<template>
    <div class="super-admin-courses">
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead>
            <template v-slot:title>{{ $t('courses') }}</template>
        </SuperAdminSchoolHead>
        <div class="select-filter-block">
            <div class="filter" style="align-items: flex-start; gap: 8px; justify-content: space-between">
                <div style="display: flex; flex-direction: row; gap: 8px">
                    <v-select class="v-select-item" :items="classTypes" item-text="title" item-value="type"
                              :label="$t('classes')" v-model="courseFilter.classType" outlined dense/>
                    <v-btn color="primary" style="height: 40px; margin: 0" class="text-no-wrap"
                           @click="filterCourses">
                        Фильтр
                    </v-btn>
<!--                    <v-btn color="primary" style="height: 40px; margin: 0" class="text-no-wrap"-->
<!--                           @click="onAdd">Добавить предмет</v-btn>-->
                </div>
                <SmartSearchInput @onTyping="onSearch"></SmartSearchInput>
                <!--                <button  class="c-smart-btn" @click="filterCourses"><span class="text&#45;&#45;transparent">Фильтр</span></button>-->
            </div>
            <!--            <div class="search-add">-->
            <!--                <SmartButton @clicked="onAdd"><span class="text-no-wrap">{{ $t('add') }} +</span></SmartButton>-->
            <!--            </div>-->
        </div>
        <SmartTable v-if="!isGrid" :schools="courses" :total-elements="totalElements" :totalPages="totalPages"
                    :page-size="pageSize" :current-page="currentPage" @leftClick="onLeftClick"
                    @rightClick="onRightClick">
            <!--<template v-slot:table-head-right>-->
                <!--<CourseMenu :is-grid="isGrid" @onChange="onMenuChange"></CourseMenu>-->
            <!--</template>-->
            <template v-slot:head>
                <th>№</th>
                <th>{{ $t('russian') }}</th>
                <th>{{ $t('kyrgyz') }}</th>
                <th>{{ $t('english') }}</th>
                <th>{{ $t('schools') }}</th>
                <th></th>
<!--                <th></th>-->
            </template>
            <template v-slot:body="{ item }">
                <td>{{ item.pos }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.courseTitleKG }}</td>
                <td>{{ item.code }}</td>
                <td>{{ item.schoolCount }}</td>
                <td>
                    <img @click="onEdit(item)" class="clickable-icons" alt=""
                         src="../../assets/images/icons/edit-green.svg">
                </td>
<!--                <td>-->
<!--                    <img @click="onDelete(item)" class="clickable-icons" alt=""-->
<!--                         src="../../assets/images/icons/trash.svg">-->
<!--                </td>-->
            </template>
        </SmartTable>
        <template v-else>
            <CourseMenu class="course-menu-grid" :is-grid="isGrid" @onChange="onMenuChange"></CourseMenu>
            <CourseGrid :courses="courses" @onEdit="onEdit" @onDelete="onDelete"></CourseGrid>
        </template>
        <v-dialog v-if="isAdd" id="add-form" v-model="isAdd" width="546">
            <AddCourse @close="onCloseModal" :is-edit="isEdit" :edit-course="course" :classTypes="classTypes"/>
        </v-dialog>
<!--        <v-dialog max-width="450" v-model="isDeleting">-->
<!--            <DeletePopup @cancel="isDeleting = false" @accept="deleteCourse"></DeletePopup>-->
<!--        </v-dialog>-->
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import AddCourse from '@/components/super-admin/courses/AddCourse'
import { AdminCourseService } from '@/_services/admin-course.service'
import CourseGrid from '@/components/super-admin/courses/CourseGrid'
import CourseMenu from '@/components/super-admin/courses/CourseMenu'
import SmartSearchInput from '@/components/input/SmartSearchInput'
import PreLoader from '@/components/preloader/PreLoader'
const adminCourseService = new AdminCourseService()

export default {
  name: 'Courses',
  components: {
    SmartSearchInput,
    CourseMenu,
    CourseGrid,
    AddCourse,
    SuperAdminSchoolHead,
    SmartTable,
    PreLoader
  },
  data: () => ({
    isLoading: false,
    required: [v => !!v || ''],
    isAdd: false,
    courses: [],
    page: 0,
    totalElements: 0,
    currentPage: 1,
    totalPages: 0,
    size: 10,
    isEdit: false,
    pageSize: 0,
    course: {},
    isDeleting: false,
    isGrid: false,
    allCourses: [],
    classTypes: [],
    courseFilter: {
      classType: 'ALL'
    }
  }),
  mounted () {
    this.fetchCourses(0)
    this.classTypes = [
      { title: this.$t('primaryClasses'), type: 'JUNIOR' },
      { title: this.$t('seniorClasses'), type: 'SENIOR' },
      { title: this.$t('all'), type: 'ALL' }
    ]
  },
  created () {
    this.fetchCourses(0)
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    }
  },
  methods: {
    filterCourses () {
      if (this.courseFilter.classType === 'ALL') {
        this.courses = this.allCourses
      } else {
        this.courses = this.allCourses.filter((course) => course.classType === this.courseFilter.classType)
      }
    },

    onCloseModal () {
      this.isAdd = false
      this.fetchCourses()
    },

    onAdd () {
      this.isAdd = true
      this.isEdit = false
    },
    onLeftClick () {
      this.currentPage--
      this.fetchCourses(this.currentPage - 1)
    },
    onRightClick () {
      this.currentPage++
      this.fetchCourses(this.currentPage - 1)
    },

    fetchCourses (page) {
      this.isLoading = true
      adminCourseService.listWithSchoolCount('', page, this.size).then((res) => {
        this.totalElements = res.totalElements
        this.totalPages = res.totalPages
        this.currentPage = res.number + 1
        this.pageSize = res.size
        if (res.content) {
          this.courses = res.content.map((i, index) => {
            i.pos = index + 1
            return i
          })
        } else this.courses = []
        this.allCourses = this.courses
        // this.totalElements = this.courses.length
        // this.pageSize = this.totalElements
        // this.currentPage = 1
        this.filterCourses()
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },
    onEdit (item) {
      this.course = item
      this.isAdd = true
      this.isEdit = true
    },
    onDelete (item) {
      this.course = item
      this.isDeleting = true
    },
    deleteCourse () {
      adminCourseService._delete(this.course.id).then(res => {
        this.$toast.success(this.$t('successDeleted'))
        this.isDeleting = false
        this.fetchCourses()
      }).catch(err => {
        console.log(err)
        this.isDeleting = false
        this.$toast.error(err)
      })
    },
    onMenuChange (val) {
      this.isGrid = val
    },
    onSearch (val) {
      if (val) {
        this.courses = this.allCourses.filter(i => i.title.toLowerCase().includes(val.toLowerCase()))
      } else this.courses = this.allCourses
    }
  }
}
</script>

<style lang="scss">
tr, th, td {
    vertical-align: middle;
}
    .super-admin-courses {
        margin: 30px;
        .v-select-item {
            max-width: 190px;
        }
        th.head {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            background: #fff;
        }
        .course-menu-grid {
            margin: 20px 30px;
        }
        .smart-table__body {
            overflow: visible;
        }
        .select-filter-block {
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;
            padding: 0 45px;
            .filter {
                display: flex;
                //align-items: center;
                width: 100%;
            }
            .search-add {
                display: flex;
                align-items: center;
                .smart-input {
                    margin-right: 15px;
                }
            }
        }
    }
    .c-smart-btn {
        background: linear-gradient(180deg, #4A27F3 0%, #339DFA 100%);
        border-radius: 24px;
        padding: 7px 12px;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
        font-family: Helvetica,sans-serif;
        color: #FFFFFF;
        &:active {
            border-radius: 24px;
            outline: none;
            border: 1px solid #4A27F3;
        }
    }
</style>
